import { Chip, Stack } from "@mui/material";
import type { FC } from "react";

type Props = {
	label: string;
};

export const ChatDayDivider: FC<Props> = ({ label }) => {
	return (
		<Stack direction="row" justifyContent="center" my={1.2}>
			<Chip variant="pill" label={label} />
		</Stack>
	);
};
